import { DgColumn, DgImage, DgText, DgSeparator } from "@dasgate/uikit";
import Vue from "vue";
import Component from "vue-class-component";

@Component({ components: { DgImage, DgColumn, DgText, DgSeparator } })
export default class SingleDocument extends Vue {}
